/**
 * Enum for message type
 * @readonly
 * @enum {string}
 */
const MESSAGE_TYPE = {
    INFO: 'info',
    WARNING: 'warning',
    ERROR: 'error',
    SUCCESS: 'success'
};

const TEXT_ALIGNMENT = {
    CENTER: 'center',
    LEFT: 'left',
    RIGHT: 'right'
}

const BUTTON_ALIGHT = {
    CENTER: 'center',
    LEFT: 'left',
    RIGHT: 'right'
}

const BUTTON_TYPE = {
    MAIN: {
        typeName: 'main',
        class: 'cgp-themes-main-cta'
    },
    SECONDARY: {
        typeName: 'secondary',
        class: 'cgp-themes-base-cta'
    },
    CUSTOM: {
      typeName: 'custom'
    }
}

const MDP_IMG_CSS_CLASS_SELECTORS = {
    COMMON_ERROR: 'cgp-mdp-common-error',
    LOGIN_ERROR_CONTACT_SUPPORT: 'cgp-mdp-login-error-contact-support',
    LOGIN_RESTRICTED_COUNTRY_ERROR: 'cgp-mdp-resticted-country-error',
    LOGIN_USERNAME_PASSWORD_WRONG: 'cgp-mdp-username-password-wrong',
    LOGIN_AGE_VERIFICATION_WARNING: 'cgp-mdp-login-age-verification-warning',
    LOGIN_CAPS_LOCK: 'cgp-mdp-login-caps-lock',
    GAME_LOW_RESOLUTION: 'cgp-mdp-game-low-resolution',
    GAME_RESTRICTED_ERROR: 'cgp-mdp-game-resticted-error',
    GAME_UNAVAILABLE: 'cgp-mdp-game-unavailable',
    GAME_REAL_MONEY_ONLY: 'cgp-mdp-game-real-money-only',
    OAUTH_INACTIVITY_WARNING: 'cgp-mdp-auth-inactivity-warning',
    OAUTH_DISCONNECT_NOTIFY: 'cgp-mdp-oauth-disconnect-notify',
    COOKIE_ENABLE_NOTIFY: 'cgp-cookie-enable-notify'
};

export {BUTTON_ALIGHT, MDP_IMG_CSS_CLASS_SELECTORS, MESSAGE_TYPE, TEXT_ALIGNMENT, BUTTON_TYPE}